import { toast } from "sonner";

// Build a clear upload-failure message that NAMES the files that failed (so staff know
// exactly which shots to re-take). Caps the list so a huge batch stays readable.
export function uploadFailureMessage(names, max = 6) {
  const list = (names || []).filter(Boolean);
  if (!list.length) return "";
  const shown = list.slice(0, max).join(", ");
  const extra = list.length > max ? `, and ${list.length - max} more` : "";
  return `Couldn't upload: ${shown}${extra} — unsupported or corrupt image, or a dropped connection.`;
}

// Show the failure toast with a one-tap "Retry failed" action that re-attempts ONLY
// the failed File objects. Common on flaky yard Wi-Fi where a file or two drops.
export function showUploadFailure(failedFiles, onRetry) {
  const names = (failedFiles || []).map((f) => f?.name || "a file");
  toast.error(uploadFailureMessage(names), {
    duration: 12000,
    action: onRetry ? { label: "Retry failed", onClick: () => onRetry(failedFiles) } : undefined,
  });
}
